import { createAsyncThunk } from "@reduxjs/toolkit";

import {
  saveRoutePointApi,
  getRoutePointsApi,
  deleteRoutePointApi,
  getWorkRoutesApi,
  saveWorkRouteApi,
  deleteWorkRouteApi,
  getRouteAssignmentsApi,
  saveRouteAssignmentApi,
  deleteRouteAssignmentApi,
  getWorkRouteAnalyticsApi,
  getRouteAreasApi,
  saveRouteAreaApi,
  deleteRouteAreaApi,
  convertAdhocToRoutePointApi,
  getMyActiveRouteAssignmentApi,
  getMyRouteScheduleApi,
} from "../../apiservice/hrpayroll";

export const fetchRoutePoints = createAsyncThunk(
  "routePoints/fetchRoutePoints",
  async (_, { rejectWithValue }) => {
    try {
      const res = await getRoutePointsApi();

      return res.data.data || [];
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  },
);

export const saveRoutePoint = createAsyncThunk(
  "routePoints/saveRoutePoint",
  async (payload, { rejectWithValue, dispatch }) => {
    try {
      const res = await saveRoutePointApi(payload);

      dispatch(fetchRoutePoints());

      return res.data;
    } catch (err) {
      console.error("saveRoutePoint API error:", err);

      return rejectWithValue({
        message:
          err.response?.data?.message ||
          err.message ||
          "Failed to save route point.",
      });
    }
  },
);

export const deleteRoutePoint = createAsyncThunk(
  "routePoints/deleteRoutePoint",
  async (payload, { rejectWithValue, dispatch }) => {
    try {
      const res = await deleteRoutePointApi(payload);

      dispatch(fetchRoutePoints());

      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  },
);

export const fetchRouteAreas = createAsyncThunk(
  "routePoints/fetchRouteAreas",
  async (_, { rejectWithValue }) => {
    try {
      const res = await getRouteAreasApi();

      return res.data.data || [];
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  },
);

export const saveRouteArea = createAsyncThunk(
  "routePoints/saveRouteArea",
  async (payload, { rejectWithValue, dispatch }) => {
    try {
      const res = await saveRouteAreaApi(payload);

      dispatch(fetchRouteAreas());

      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  },
);

export const deleteRouteArea = createAsyncThunk(
  "routePoints/deleteRouteArea",
  async (payload, { rejectWithValue, dispatch }) => {
    try {
      const res = await deleteRouteAreaApi(payload);

      dispatch(fetchRouteAreas());

      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  },
);

export const fetchWorkRoutes = createAsyncThunk(
  "workRoutes/fetchWorkRoutes",
  async (_, { rejectWithValue }) => {
    try {
      const res = await getWorkRoutesApi();

      return res.data.data || [];
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  },
);

export const saveWorkRoute = createAsyncThunk(
  "workRoutes/saveWorkRoute",
  async (payload, { rejectWithValue, dispatch }) => {
    try {
      const res = await saveWorkRouteApi(payload);

      dispatch(fetchWorkRoutes());

      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  },
);

export const deleteWorkRoute = createAsyncThunk(
  "workRoutes/deleteWorkRoute",
  async (payload, { rejectWithValue, dispatch }) => {
    try {
      const res = await deleteWorkRouteApi(payload);

      dispatch(fetchWorkRoutes());

      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  },
);

export const fetchRouteAssignments = createAsyncThunk(
  "workRoutes/fetchRouteAssignments",

  async (_, { rejectWithValue }) => {
    try {
      const res = await getRouteAssignmentsApi();

      return res.data.data || [];
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  },
);

export const fetchMyActiveRouteAssignment = createAsyncThunk(
  "workRoutes/fetchMyActiveRouteAssignment",

  async (_, { rejectWithValue }) => {
    try {
      const res = await getMyActiveRouteAssignmentApi();
      const result =  res?.data?.data || [];
      const reasonMap = {
          sick_leave: "Sick Leave",
          casual_leave: "Casual Leave",
          annual_leave: "Annual Leave",
          personal_emergency:
            "Personal Emergency",
          vehicle_breakdown:
            "Vehicle Breakdown",
          emergency_duty:
            "Emergency Duty",
          other: "Other",
        };

      if(result.execution_reason){
        result.execution_reason = reasonMap[result.execution_reason] || result.execution_reason;
      }
      return result;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  },
);

export const saveRouteAssignment = createAsyncThunk(
  "workRoutes/saveRouteAssignment",

  async (payload, { rejectWithValue, dispatch }) => {
    try {
      const res = await saveRouteAssignmentApi(payload);

      dispatch(fetchRouteAssignments());

      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  },
);

export const deleteRouteAssignment = createAsyncThunk(
  "workRoutes/deleteRouteAssignment",

  async (payload, { rejectWithValue, dispatch }) => {
    try {
      const res = await deleteRouteAssignmentApi(payload);

      dispatch(fetchRouteAssignments());

      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  },
);

export const fetchWorkRouteAnalytics = createAsyncThunk(
  "workRoutes/fetchWorkRouteAnalytics",
  async (payload = {}, { rejectWithValue }) => {
    try {
      const res = await getWorkRouteAnalyticsApi(payload);

      return res.data.data || {};
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

export const convertAdhocToRoutePoint = createAsyncThunk(
  "workRoutes/convertAdhocToRoutePoint",

  async (payload, { rejectWithValue, dispatch }) => {
    try {
      const res = await convertAdhocToRoutePointApi(payload);

      dispatch(fetchRoutePoints());

      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  },
);

export const fetchMyRouteSchedule = createAsyncThunk(
  "workRoutes/fetchMyRouteSchedule",
  async (payload, { rejectWithValue }) => {
    try {
      const res = await getMyRouteScheduleApi(payload);

      return res.data.data || [];
    } catch (err) {
      return rejectWithValue(
        err.response?.data || err.message
      );
    }
  }
);